module.exports = __webpack_public_path__ + "img/undraw_select_player_64ca.594d40cc.svg";